import React, { Component } from 'react';
import CongresistasDataService from "../../../Services/Catalogo/Congresistas.Service";
import UtilsService from "../../../Services/General/Utils.Service";
import Input from "../../../Components/Input";
import 'react-dropzone-uploader/dist/styles.css'
import DatePicker from '../../../Components/DatePicker';
import Spinner from '../../../Components/Spinner';
import Select from '../../../Components/Select';
import FileInput from '../../../Components/FileInput';
import MoneyInput from '../../../Components/MoneyInput';
import ValidForm from "../../../Utils/ValidForm";
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import AuthLogin from "../../../Utils/AuthLogin";
import { ModuloPermiso } from "../../../Permisos/ModuloPermiso";
import ValidarPermiso from "../../../Permisos/ValidarPermiso";

const auth = new AuthLogin();

/* constantes select */
const default_item_select_organo = { value: "", label: "Seleccione órgano" };
const default_item_select_calidad_miembro = { value: "", label: "Seleccione calidad de miembro" };
const default_item_select_pais = { value: "", label: "Seleccione país" };
const default_item_select_departamento = { value: "", label: "Seleccione departamento" };
const default_item_select_parentesco = { value: "", label: "Seleccione parentesco" };
const default_item_select_concepto = { value: "", label: "Seleccione concepto" };
const default_item_select_tipo_bien = { value: "", label: "Seleccione tipo de bien" };
const default_item_select_tipo_documento = { value: "", label: "Seleccione tipo de documento" };

/* constantes tables */
const default_item_congresistas_cf_juntas_asociaciones = { id: 0, congresista_detalle_id: 0, nombre_entidad: "", cf_organo_id: 0, cf_calidad_miembro_id: 0, pais_id: 0, activo: 1, organo_select: Object.assign({}, default_item_select_organo), calidad_miembro_select: Object.assign({}, default_item_select_calidad_miembro), pais_select: Object.assign({}, default_item_select_pais) };
const default_item_congresistas_cf_info_cercanias = { id: 0, congresista_detalle_id: 0, nombre: "", cf_parentesco_id: 0, conflicto_interes: "", activo: 1, parentesco_select: Object.assign({}, default_item_select_parentesco) };
const default_item_congresistas_cf_acreencias = { id: 0, congresista_detalle_id: 0, cf_acreencia_cpt: '', saldo: 0, activo: 1}; /* cpt = concepto */
const default_item_congresistas_cf_bienes = { id: 0, congresista_detalle_id: 0, cf_tipo_bien: '', pais_id: 0, cf_departamento_id: 0, valor: 0, activo: 1, pais_select: Object.assign({}, default_item_select_pais), departamento_select: Object.assign({}, default_item_select_departamento), dataSelectDepartamentos: [] };
const default_item_congresistas_cf_documentos = { id: 0, congresista_detalle_id: 0, cf_tipo_documento_id: 0, year: new Date().getFullYear(), nombre: "", url_documento: "", documento: null, activo: 1, tipo_documento_select: Object.assign({}, default_item_select_tipo_documento), dpYear: new Date() };

const constFileds = {
    user: auth.username(),
    congresistas_cf_generals: {
        id: 0,
        congresista_detalle_id: 0,
        conflictos_declarados: "",
        actividad_economica: ""
    },
    congresistas_cf_juntas_asociaciones: [
        Object.assign({}, default_item_congresistas_cf_juntas_asociaciones)
    ],
    congresistas_cf_info_cercanias: [
        Object.assign({}, default_item_congresistas_cf_info_cercanias)
    ],
    congresistas_cf_ingresos: {
        id: 0,
        congresista_detalle_id: 0,
        salario_anual: 0,
        interes_cesantias_anual: 0,
        gasto_representacion_anual: 0,
        arriendo_anual: 0,
        honorario_anual: 0,
        otros_anual: 0,
        total_anual: 0
    },
    congresistas_cf_acreencias: [
        Object.assign({}, default_item_congresistas_cf_acreencias)
    ],
    congresistas_cf_bienes: [
        Object.assign({}, default_item_congresistas_cf_bienes)
    ],
    congresistas_cf_documentos: [
        Object.assign({}, default_item_congresistas_cf_documentos)
    ]
}
const constErrors = {

}
const buttonList = [
    ['undo', 'redo',
        'font', 'fontSize', 'formatBlock',
        'paragraphStyle', 'blockquote',
        'bold', 'underline', 'italic', 'strike', 'subscript', 'superscript',
        'fontColor', 'hiliteColor', 'textStyle',
        'removeFormat',
        'outdent', 'indent',
        'align', 'horizontalRule', 'list', 'lineHeight',
        'table', 'link', 'image', 'video', 'audio', /** 'math', */ // You must add the 'katex' library at options to use the 'math' plugin.
        /** 'imageGallery', */ // You must add the "imageGalleryUrl".
        'fullScreen', 'showBlocks', 'codeView',
        'preview', 'print', 'save', 'template']
];

let validForm = new ValidForm();

class EditarCongresistaConflictoInteres extends Component {
    constructor(props) {
        super(props);
        /* Estos parámetros nos serviran para regresar a la corporacion y cuatrienio en el que estábamos por si a caso (recordemos que al guardar no se regresará) */
        const id = this.props.match.params.id === undefined ? 0 : this.props.match.params.id;
        const congresista_id = this.props.match.params.congresista_id === undefined ? 0 : this.props.match.params.congresista_id;
        const idCuatrienio = this.props.match.params.idCuatrienio === undefined ? 0 : this.props.match.params.idCuatrienio;
        const idCorporacion = this.props.match.params.idCorporacion === undefined ? 0 : this.props.match.params.idCorporacion;
        validForm = new ValidForm();
        this.state = {
            congresista_id: congresista_id,
            id: id,
            idCuatrienio,
            idCorporacion,
            loading: false,
            congresista: {
                persona_id: 0,
                persona: {
                    id: 0,
                    nombres: "",
                    apellidos: "",
                }
            },
            data: Object.assign({}, constFileds),
            errors: Object.assign({}, constErrors),
            dataSelectOrgano: [],
            dataSelectCalidadMiembro: [],
            dataSelectPais: [],
            dataSelectDepartamento: [],
            dataSelectParentesco: [],
            dataSelectConcepto: [],
            dataSelectTipoBien: [],
            dataSelectTipoDocumento: [
                { value: 0, label: "Seleccione tipo de documento" },
                { value: 1, label: "Reportes de campaña" },
                { value: 2, label: "Declaración de renta" },
                { value: 3, label: "Declaración de conflictos de interés" }
            ]
        }
    }

    handlerSetTotalIngresos = () => {
        let ingresos = this.state.data.congresistas_cf_ingresos;
        ingresos.total_anual = Number(ingresos.salario_anual) + Number(ingresos.interes_cesantias_anual) + Number(ingresos.gasto_representacion_anual) + Number(ingresos.arriendo_anual) + Number(ingresos.honorario_anual) + Number(ingresos.otros_anual);
        this.setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                congresistas_cf_ingresos: ingresos
            }
        }));
    }

    handlerAddJuntasAsociaciones = async () => {
        let item = Object.assign({}, default_item_congresistas_cf_juntas_asociaciones);
        // let itemError = Object.assign({}, default_item_error_congresistas_cf_juntas_asociaciones);

        this.setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                congresistas_cf_juntas_asociaciones: [
                    ...prevState.data.congresistas_cf_juntas_asociaciones,
                    item,
                ],
            },
            // errors: {
            //     ...prevState.errors,
            //     congresistas_cf_juntas_asociaciones: [
            //         ...prevState.errors.congresistas_cf_juntas_asociaciones,
            //         itemError,
            //     ],
            // }
        }));
    }

    handlerDeleteJuntasAsociaciones = (item, index) => {
        let juntas = this.state.data.congresistas_cf_juntas_asociaciones;
        if (item.id === 0) {
            juntas.splice(index, 1);
        } else {
            item.activo = 0;
        }
        this.setState(prevState => ({
            ...prevState,
            data: {
                ...prevState.data,
                congresistas_cf_juntas_asociaciones: juntas
            }
        }));
    }

    handlerAddCercanias = async () => {
        let item = Object.assign({}, default_item_congresistas_cf_info_cercanias);
        // let itemError = Object.assign({}, default_item_error_congresistas_cf_info_cercanias);

        this.setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                congresistas_cf_info_cercanias: [
                    ...prevState.data.congresistas_cf_info_cercanias,
                    item,
                ],
            },
            // errors: {
            //     ...prevState.errors,
            //     congresistas_cf_info_cercanias: [
            //         ...prevState.errors.congresistas_cf_info_cercanias,
            //         itemError,
            //     ],
            // }
        }));
    }

    handlerDeleteCercanias = (item, index) => {
        let cercanias = this.state.data.congresistas_cf_info_cercanias;
        if (item.id === 0) {
            cercanias.splice(index, 1);
        } else {
            item.activo = 0;
        }
        this.setState(prevState => ({
            ...prevState,
            data: {
                ...prevState.data,
                congresistas_cf_info_cercanias: cercanias
            }
        }));
    }

    handlerAddAcreencias = async () => {
        let item = Object.assign({}, default_item_congresistas_cf_acreencias);

        this.setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                congresistas_cf_acreencias: [
                    ...prevState.data.congresistas_cf_acreencias,
                    item,
                ],
            },
        }));
    }

    handlerDeleteAcreencias = (item, index) => {
        let acreencias = this.state.data.congresistas_cf_acreencias;
        if (item.id === 0) {
            acreencias.splice(index, 1);
        } else {
            item.activo = 0;
        }
        this.setState(prevState => ({
            ...prevState,
            data: {
                ...prevState.data,
                congresistas_cf_acreencias: acreencias
            }
        }));
    }

    handlerAddBienes = async () => {
        let item = Object.assign({}, default_item_congresistas_cf_bienes);
        // let itemError = Object.assign({}, default_item_error_congresistas_cf_bienes);

        this.setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                congresistas_cf_bienes: [
                    ...prevState.data.congresistas_cf_bienes,
                    item,
                ],
            },
            // errors: {
            //     ...prevState.errors,
            //     congresistas_cf_bienes: [
            //         ...prevState.errors.congresistas_cf_bienes,
            //         itemError,
            //     ],
            // }
        }));
    }

    handlerDeleteBienes = (item, index) => {
        let bienes = this.state.data.congresistas_cf_bienes;
        if (item.id === 0) {
            bienes.splice(index, 1);
        } else {
            item.activo = 0;
        }
        this.setState(prevState => ({
            ...prevState,
            data: {
                ...prevState.data,
                congresistas_cf_bienes: bienes
            }
        }));
    }

    handlerAddDocumentos = async () => {
        let item = Object.assign({}, default_item_congresistas_cf_documentos);
        // let itemError = Object.assign({}, default_item_error_congresistas_cf_documentos);

        this.setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                congresistas_cf_documentos: [
                    ...prevState.data.congresistas_cf_documentos,
                    item,
                ],
            },
            // errors: {
            //     ...prevState.errors,
            //     congresistas_cf_documentos: [
            //         ...prevState.errors.congresistas_cf_documentos,
            //         itemError,
            //     ],
            // }
        }));
    }

    handlerDeleteDocumentos = (item, index) => {
        let documentos = this.state.data.congresistas_cf_documentos;
        if (item.id === 0) {
            documentos.splice(index, 1);
        } else {
            item.activo = 0;
        }
        this.setState(prevState => ({
            ...prevState,
            data: {
                ...prevState.data,
                congresistas_cf_documentos: documentos
            }
        }));
    }

    componentDidMount = async () => {
        await this.getComboCfOrgano(1);
        await this.getComboPaises(1);
        await this.getComboCfCalidadMiembro(1);
        await this.getComboCfParentesco(1);
        //await this.getComboCfAcreenciaCpt(1);
        //await this.getComboCfTipoBien(1);

        await this.getCongresistaById();
        await this.getConflictoInteres();
    }

    getCongresistaById = async () => {
        let id = this.state.congresista_id;
        await CongresistasDataService.get(id).then(response => {
            this.setState({ congresista: response.data[0] })
        })
    }

    getItemFromArray = (id_to_find, data) => {
        id_to_find = parseInt(id_to_find);
        for (let i = 0; i < data.length; i++) {
            let current_item = data[i];
            if (parseInt(current_item.value) === id_to_find) {
                return current_item;
            }
        }
    }

    getConflictoInteres = async () => {
        let id = this.state.id;
        this.setState({ loading: true })
        await CongresistasDataService.getConflictoInteresByCongresistaId(id).then(async response => {
            let data = Object.assign({}, constFileds)
            let result = response.data;

            if (result) {
                data.congresistas_cf_generals = {
                    id: result.id,
                    congresista_detalle_id: result.congresista_detalle_id,
                    conflictos_declarados: result.conflictos_declarados,
                    actividad_economica: result.actividad_economica,
                }

                if (result.juntas.length > 0) {
                    let juntas = [];
                    for (let i = 0; i < result.juntas.length; i++) {
                        let item = Object.assign({}, default_item_congresistas_cf_juntas_asociaciones);
                        let resultItemJunta = result.juntas[i];

                        let organo_select = this.getItemFromArray(resultItemJunta.cf_organo_id, this.state.dataSelectOrgano);
                        if (!organo_select) {
                            organo_select = Object.assign({}, default_item_select_organo);
                        }

                        let calidad_miembro_select = this.getItemFromArray(resultItemJunta.cf_calidad_miembro_id, this.state.dataSelectCalidadMiembro);
                        if (!calidad_miembro_select) {
                            calidad_miembro_select = Object.assign({}, default_item_select_calidad_miembro);
                        }

                        let pais_select = this.getItemFromArray(resultItemJunta.pais_id, this.state.dataSelectPais);
                        if (!pais_select) {
                            pais_select = Object.assign({}, default_item_select_pais);
                        }

                        item = {
                            id: resultItemJunta.id,
                            congresista_detalle_id: resultItemJunta.congresista_detalle_id,
                            nombre_entidad: resultItemJunta.nombre_entidad,
                            cf_organo_id: resultItemJunta.cf_organo_id,
                            cf_calidad_miembro_id: resultItemJunta.cf_calidad_miembro_id,
                            pais_id: resultItemJunta.pais_id,
                            activo: resultItemJunta.activo,
                            organo_select: organo_select,
                            calidad_miembro_select: calidad_miembro_select,
                            pais_select: pais_select
                        }

                        juntas.push(item);
                    }
                    data.congresistas_cf_juntas_asociaciones = juntas;
                }

                if (result.cercanias.length > 0) {
                    let cercanias = [];
                    for (let i = 0; i < result.cercanias.length; i++) {
                        let item = Object.assign({}, default_item_congresistas_cf_info_cercanias);
                        let resultItemCercania = result.cercanias[i];

                        let parentesco_select = this.getItemFromArray(resultItemCercania.cf_parentesco_id, this.state.dataSelectParentesco);
                        if (!parentesco_select) {
                            parentesco_select = Object.assign({}, default_item_select_parentesco);
                        }

                        item = {
                            id: resultItemCercania.id,
                            congresista_detalle_id: resultItemCercania.congresista_detalle_id,
                            nombre: resultItemCercania.nombre,
                            cf_parentesco_id: resultItemCercania.cf_parentesco_id,
                            conflicto_interes: resultItemCercania.conflicto_interes,
                            activo: resultItemCercania.activo,
                            parentesco_select: parentesco_select
                        }

                        cercanias.push(item);
                    }
                    data.congresistas_cf_info_cercanias = cercanias;
                }

                if (result.ingresos.length > 0) {
                    let resultIngresos = result.ingresos[0];
                    data.congresistas_cf_ingresos = {
                        id: resultIngresos.id,
                        congresista_detalle_id: resultIngresos.congresista_detalle_id,
                        salario_anual: parseFloat(resultIngresos.salario_anual),
                        interes_cesantias_anual: parseFloat(resultIngresos.interes_cesantias_anual),
                        gasto_representacion_anual: parseFloat(resultIngresos.gasto_representacion_anual),
                        arriendo_anual: parseFloat(resultIngresos.arriendo_anual),
                        honorario_anual: parseFloat(resultIngresos.honorario_anual),
                        otros_anual: parseFloat(resultIngresos.otros_anual),
                        total_anual: parseFloat(resultIngresos.total_anual)
                    };
                }

                if (result.acreencias.length > 0) {
                    let acreencias = [];
                    for (let i = 0; i < result.acreencias.length; i++) {
                        let item = Object.assign({}, default_item_congresistas_cf_acreencias);
                        let resultItemAcreencias = result.acreencias[i];

                        item = {
                            id: resultItemAcreencias.id,
                            congresista_detalle_id: resultItemAcreencias.congresista_detalle_id,
                            cf_acreencia_cpt: resultItemAcreencias.cf_acreencia_cpt,
                            saldo: resultItemAcreencias.saldo,
                            activo: resultItemAcreencias.activo
                        }

                        acreencias.push(item);
                    }
                    data.congresistas_cf_acreencias = acreencias;
                }

                if (result.bienes.length > 0) {
                    let bienes = [];
                    for (let i = 0; i < result.bienes.length; i++) {
                        let item = Object.assign({}, default_item_congresistas_cf_bienes);
                        let resultItemBienes = result.bienes[i];

                        let pais_select = this.getItemFromArray(resultItemBienes.pais_id, this.state.dataSelectPais);
                        if (!pais_select) {
                            pais_select = Object.assign({}, default_item_select_pais);
                        }

                        let dataSelectDepartamentos = await this.getComboCfDepartamentoBienes(1, resultItemBienes.pais_id);

                        let departamento_select = this.getItemFromArray(resultItemBienes.cf_departamento_id, dataSelectDepartamentos);
                        if (!departamento_select) {
                            departamento_select = Object.assign({}, default_item_select_departamento);
                        }

                        item = {
                            id: resultItemBienes.id,
                            congresista_detalle_id: resultItemBienes.congresista_detalle_id,
                            cf_tipo_bien: resultItemBienes.cf_tipo_bien,
                            pais_id: resultItemBienes.pais_id,
                            cf_departamento_id: resultItemBienes.cf_departamento_id,
                            valor: resultItemBienes.valor,
                            activo: resultItemBienes.activo,
                            pais_select: pais_select,
                            departamento_select: departamento_select,
                            dataSelectDepartamentos: dataSelectDepartamentos
                        }

                        bienes.push(item);
                    }
                    data.congresistas_cf_bienes = bienes;
                }

                if (result.documentos.length > 0) {
                    let documentos = [];
                    for (let i = 0; i < result.documentos.length; i++) {
                        let item = Object.assign({}, default_item_congresistas_cf_documentos);
                        let resultItemDocumentos = result.documentos[i];

                        let tipo_documento_select = this.getItemFromArray(resultItemDocumentos.cf_tipo_documento_id, this.state.dataSelectTipoDocumento);
                        if (!tipo_documento_select) {
                            tipo_documento_select = Object.assign({}, default_item_select_tipo_documento);
                        }

                        let year = resultItemDocumentos.year;
                        let dpYear = new Date(resultItemDocumentos.year, 0);

                        item = {
                            id: resultItemDocumentos.id,
                            congresista_detalle_id: resultItemDocumentos.congresista_detalle_id,
                            cf_tipo_documento_id: resultItemDocumentos.cf_tipo_documento_id,
                            year: year,
                            nombre: resultItemDocumentos.nombre,
                            url_documento: resultItemDocumentos.url_documento,
                            documento: null,
                            activo: resultItemDocumentos.activo,
                            tipo_documento_select: tipo_documento_select,
                            dpYear: dpYear
                        }

                        documentos.push(item);
                    }
                    data.congresistas_cf_documentos = documentos;
                }
            }

            this.setState(prevState => ({
                ...prevState,
                data: data,
                loading: false
            }));
        });
    }

    getComboPaises = async (activo) => {
        this.setState({ loading: true });
        await UtilsService.getPaisFilter({ activo: activo }).then((response) => {
            let combo_pais = [];
            response.data.forEach((i) => {
                combo_pais.push({ value: i.id, label: i.nombre });
            });
            combo_pais.unshift(Object.assign({}, default_item_select_pais));
            this.setState({
                dataSelectPais: combo_pais,
                loading: false,
            });
        });
    };

    getComboCfCalidadMiembro = async (activo) => {
        this.setState({ loading: true });
        await UtilsService.getCfCalidadMiembroFilter({ activo: activo }).then((response) => {
            let combo_calidad_miembro = [];
            response.data.forEach((i) => {
                combo_calidad_miembro.push({ value: i.id, label: i.Nombre });
            });
            combo_calidad_miembro.unshift(Object.assign({}, default_item_select_calidad_miembro));
            this.setState({
                dataSelectCalidadMiembro: combo_calidad_miembro,
                loading: false,
            });
        });
    };

    getComboCfOrgano = async (activo) => {
        this.setState({ loading: true });
        await UtilsService.getCfOrganoFilter({ activo: activo }).then((response) => {
            let combo_organo = [];
            response.data.forEach((i) => {
                combo_organo.push({ value: i.id, label: i.Nombre });
            });
            combo_organo.unshift(Object.assign({}, default_item_select_organo));
            this.setState({
                dataSelectOrgano: combo_organo,
                loading: false,
            });
        });
    };

    getComboCfParentesco = async (activo) => {
        this.setState({ loading: true });
        await UtilsService.getCfParentescoFilter({ activo: activo }).then((response) => {
            let combo_parentesco = [];
            response.data.forEach((i) => {
                combo_parentesco.push({ value: i.id, label: i.Nombre });
            });
            combo_parentesco.unshift(Object.assign({}, default_item_select_parentesco));
            this.setState({
                dataSelectParentesco: combo_parentesco,
                loading: false,
            });
        });
    };

    getComboCfAcreenciaCpt = async (activo) => {
        this.setState({ loading: true });
        await UtilsService.getCfAcreenciasCptFilter({ activo: activo }).then((response) => {
            let combo_acreencia_cpt = [];
            response.data.forEach((i) => {
                combo_acreencia_cpt.push({ value: i.id, label: i.Nombre });
            });
            combo_acreencia_cpt.unshift(Object.assign({}, default_item_select_concepto));
            this.setState({
                dataSelectConcepto: combo_acreencia_cpt,
                loading: false,
            });
        });
    };

    getComboCfTipoBien = async (activo) => {
        this.setState({ loading: true });
        await UtilsService.getCfTipoBienFilter({ activo: activo }).then((response) => {
            let combo_tipo_bien = [];
            response.data.forEach((i) => {
                combo_tipo_bien.push({ value: i.id, label: i.Nombre });
            });
            combo_tipo_bien.unshift(Object.assign({}, default_item_select_tipo_bien));
            this.setState({
                dataSelectTipoBien: combo_tipo_bien,
                loading: false,
            });
        });
    };

    getComboCfDepartamento = async (activo, pais_id) => {
        this.setState({ loading: true });
        await UtilsService.getCfDepartamentoFilter({ activo: activo, pais_id: pais_id }).then((response) => {
            let combo_cf_departamento = [];
            response.data.forEach((i) => {
                combo_cf_departamento.push({ value: i.id, label: i.nombre });
            });
            combo_cf_departamento.unshift(Object.assign({}, default_item_select_departamento));
            this.setState({
                dataSelectDepartamento: combo_cf_departamento,
                loading: false,
            });
        });
    };

    getComboCfDepartamentoBienes = async (activo, pais_id) => {
        this.setState({ loading: true });
        let combo_cf_departamento = [];
        await UtilsService.getCfDepartamentoFilter({ activo: activo, pais_id: pais_id }).then((response) => {
            response.data.forEach((i) => {
                combo_cf_departamento.push({ value: i.id, label: i.nombre });
            });
            combo_cf_departamento.unshift(Object.assign({}, default_item_select_departamento));
        });

        return combo_cf_departamento;
    };

    resetFields() {
        let fields = validForm.resetObject(constFileds);
        let errors = validForm.resetObject(constErrors);

        this.setState({ data: fields, errors: errors });
    }

    saveSubmit = async () => {
        this.setState({ loading: true });
        let data = this.state.data;
        let errors = this.state.errors;
        let responseData;
        errors = validForm.cleanErrors(errors);
        data.congresistas_cf_generals.congresista_detalle_id = this.state.id;

        for(let i = 0; i < data.congresistas_cf_bienes.length; i++){
            delete data['congresistas_cf_bienes'][i]['dataSelectDepartamentos'];
        }

        await CongresistasDataService.saveConflictoInteres(data)
            .then(response => {
                this.props.history.push({
                    pathname: `/congresistas-por-cuatrienio/cuatrienio-${this.state.idCuatrienio}/corporacion-${this.state.idCorporacion}`
                });
            })
            .catch(function (error) {
                errors = validForm.displayErrors(error.response.data, errors);
            });
    }

    handlerChangeFile = async (element, index) => {
        let documentos = this.state.data.congresistas_cf_documentos;
        documentos[index].documento = element.target.files[0];
        documentos[index].nombre = element.target.files[0].name;

        this.setState(prevState => ({
            ...prevState,
            data: {
                ...prevState.data,
                congresistas_cf_documentos: documentos
            }
        }));
    }

    handlerChangeMoney = async (value, propertyToSetValue, index) => {
        let ingresos = this.state.data.congresistas_cf_ingresos;
        ingresos[propertyToSetValue] = value;
        this.setState(prevState => ({
            ...prevState,
            data: {
                ...prevState.data,
                congresistas_cf_ingresos: ingresos
            }
        }));
        this.handlerSetTotalIngresos();
    }

    handlerChangeMoneyAcreencias = async (value, propertyToSetValue, index) => {
        let acreencias = this.state.data.congresistas_cf_acreencias;
        acreencias[index].saldo = value;
        this.setState(prevState => ({
            ...prevState,
            data: {
                ...prevState.data,
                congresistas_cf_acreencias: acreencias
            }
        }));
    }

    handlerChangeMoneyBienes = async (value, propertyToSetValue, index) => {
        let bienes = this.state.data.congresistas_cf_bienes;
        bienes[index].valor = value;
        this.setState(prevState => ({
            ...prevState,
            data: {
                ...prevState.data,
                congresistas_cf_bienes: bienes
            }
        }));
    }

    render() {
        return (
            <>
                <Spinner show={this.state.loading} />
                <ul className="breadcrumb">
                    <li>Catálogos</li>
                    <li>Congresistas</li>
                    <li>Listado de congresistas por cuatrienio</li>
                    <li>Conflictos de interés </li>
                </ul>
                <div className="page-content-wrap">
                    <div className="row">
                        <div className="col-md-12">

                            <form className="form-horizontal">
                                <div className="panel panel-default">
                                    <div className="panel-heading">
                                        <h3 className="panel-title"><strong><i className="fas fa-address-book" /> {this.state.congresista.persona.nombres} {this.state.congresista.persona.apellidos} | Conflictos de interés</strong></h3>
                                    </div>

                                    <div className="panel-body">
                                        <div className="panel panel-default tabs">
                                            <ul className="nav nav-tabs">
                                                <li className="active"><a href={`#tab-info-general`} data-toggle="tab">Información general</a></li>
                                                <li><a href={`#tab-juntas-consejos`} data-toggle="tab">Participación en Juntas Directivas, Consejos, Corporaciones, Sociedades y/o Asociaciones </a></li>
                                                <li><a href={`#tab-info-cercanias`} data-toggle="tab">Información de cónyuge, compañero(a) permanente y/o parientes </a></li>
                                                <li><a href={`#tab-ingresos`} data-toggle="tab">Ingresos</a></li>
                                                <li><a href={`#tab-acreencias`} data-toggle="tab">Acreencias</a></li>
                                                <li><a href={`#tab-bienes`} data-toggle="tab">Bienes patrimoniales </a></li>
                                                <li><a href={`#tab-documentos`} data-toggle="tab">Documentos de soporte</a></li>
                                            </ul>
                                            <div className="panel-body tab-content row">
                                                <div className={`tab-pane active`} id={`tab-info-general`}>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label className="col-md-3 control-label">Conflictos declarados</label>
                                                            <div className="col-md-9">
                                                                <SunEditor
                                                                    placeholder="..."
                                                                    setContents={this.state.data.congresistas_cf_generals.conflictos_declarados || ""}
                                                                    onChange={(e) => {
                                                                        let general = this.state.data.congresistas_cf_generals;
                                                                        let errors = this.state.errors;
                                                                        general = validForm.handleChangeFieldJodiEditor("conflictos_declarados", general, e);
                                                                        // errors = validForm.handleChangeErrors("perfil_educativo", errors, e);
                                                                        this.setState(prevState => ({
                                                                            ...prevState,
                                                                            data: {
                                                                                ...prevState.data,
                                                                                congresistas_cf_generals: general
                                                                            }
                                                                        }));
                                                                    }}
                                                                    lang="es"
                                                                    setOptions={{
                                                                        buttonList: buttonList,
                                                                        height: 400,
                                                                    }}
                                                                />
                                                                <span className="error">
                                                                    {/* {this.state.errors.perfil_educativo || ""} */}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="col-md-3 control-label">Actividad económica privada</label>
                                                            <div className="col-md-9">
                                                                <SunEditor
                                                                    placeholder="..."
                                                                    setContents={this.state.data.congresistas_cf_generals.actividad_economica || ""}
                                                                    onChange={(e) => {
                                                                        let general = this.state.data.congresistas_cf_generals;
                                                                        let errors = this.state.errors;
                                                                        general = validForm.handleChangeFieldJodiEditor("actividad_economica", general, e);
                                                                        // errors = validForm.handleChangeErrors("perfil_educativo", errors, e);
                                                                        this.setState(prevState => ({
                                                                            ...prevState,
                                                                            data: {
                                                                                ...prevState.data,
                                                                                congresistas_cf_generals: general
                                                                            }
                                                                        }));
                                                                    }}
                                                                    lang="es"
                                                                    setOptions={{
                                                                        buttonList: buttonList,
                                                                        height: 400,
                                                                    }}
                                                                />
                                                                <span className="error">
                                                                    {/* {this.state.errors.perfil_educativo || ""} */}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`tab-pane`} id={`tab-juntas-consejos`}>
                                                    <div className="col-md-12">
                                                        <div className="formCardsContainer three-columns">
                                                            {
                                                                this.state.data.congresistas_cf_juntas_asociaciones.map((x, i) => {
                                                                    if (x.activo === 1) {
                                                                        return (
                                                                            <div key={i} className="formCard">
                                                                                <button onClick={() => { this.handlerDeleteJuntasAsociaciones(x, i) }} type="button" className="deleteFormCard"><i className="fas fa-trash-alt" /></button>
                                                                                <div className="form-group">
                                                                                    <div className="col-md-12">
                                                                                        <label htmlFor="">Nombre de entidad o institución</label>
                                                                                        <Input divClass="input-group"
                                                                                            inputName="trayectoria_publica_cargo"
                                                                                            inputType="text"
                                                                                            inputClass="form-control"
                                                                                            inputplaceholder="Escriba nombre de entidad"
                                                                                            inputValue={x.nombre_entidad || ''}
                                                                                            inputOnchange={e => {
                                                                                                let juntas = this.state.data.congresistas_cf_juntas_asociaciones;
                                                                                                juntas[i].nombre_entidad = e.currentTarget.value;
                                                                                                this.setState(prevState => ({
                                                                                                    ...prevState,
                                                                                                    data: {
                                                                                                        ...prevState.data,
                                                                                                        congresistas_cf_juntas_asociaciones: juntas
                                                                                                    }
                                                                                                }));
                                                                                            }}
                                                                                            spanClass="error"
                                                                                            // spanError={this.state.errors["congresistas_cf_juntas_asociaciones"][i]["nombre_entidad"] || ""}
                                                                                            divClassSpanType={1}
                                                                                            divClassSpan="input-group-addon"
                                                                                            divClassSpanI="fa fa-indent" />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="form-group">
                                                                                    <div className="col-md-12">
                                                                                        <label htmlFor="">Órgano</label>
                                                                                        <Select
                                                                                            divClass=""
                                                                                            selectplaceholder="Seleccione"
                                                                                            selectValue={x.organo_select}
                                                                                            selectIsSearchable={true}
                                                                                            selectoptions={this.state.dataSelectOrgano}
                                                                                            selectOnchange={(selected) => {
                                                                                                let juntas = this.state.data.congresistas_cf_juntas_asociaciones;
                                                                                                juntas[i].cf_organo_id = selected.value;
                                                                                                juntas[i].organo_select = selected;
                                                                                                this.setState(prevState => ({
                                                                                                    ...prevState,
                                                                                                    data: {
                                                                                                        ...prevState.data,
                                                                                                        congresistas_cf_juntas_asociaciones: juntas
                                                                                                    }
                                                                                                }));
                                                                                            }}
                                                                                            selectclassNamePrefix="selectReact__value-container"
                                                                                            spanClass="error"
                                                                                        // spanError={this.state.errors["congresistas_cf_juntas_asociaciones"][i]["cf_organo_id"] || ''}
                                                                                        >
                                                                                        </Select>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="form-group">
                                                                                    <div className="col-md-12">
                                                                                        <label htmlFor="">Calidad de miembro</label>
                                                                                        <Select
                                                                                            divClass=""
                                                                                            selectplaceholder="Seleccione"
                                                                                            selectValue={x.calidad_miembro_select}
                                                                                            selectIsSearchable={true}
                                                                                            selectoptions={this.state.dataSelectCalidadMiembro}
                                                                                            selectOnchange={(selected) => {
                                                                                                let juntas = this.state.data.congresistas_cf_juntas_asociaciones;
                                                                                                juntas[i].cf_calidad_miembro_id = selected.value;
                                                                                                juntas[i].calidad_miembro_select = selected;
                                                                                                this.setState(prevState => ({
                                                                                                    ...prevState,
                                                                                                    data: {
                                                                                                        ...prevState.data,
                                                                                                        congresistas_cf_juntas_asociaciones: juntas
                                                                                                    }
                                                                                                }));
                                                                                            }}
                                                                                            selectclassNamePrefix="selectReact__value-container"
                                                                                            spanClass="error"
                                                                                        // spanError={this.state.errors["congresistas_cf_juntas_asociaciones"][i]["cf_calidad_miembro_id"] || ''}
                                                                                        >
                                                                                        </Select>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="form-group">
                                                                                    <div className="col-md-12">
                                                                                        <label htmlFor="">País</label>
                                                                                        <Select
                                                                                            divClass=""
                                                                                            selectplaceholder="Seleccione"
                                                                                            selectValue={x.pais_select}
                                                                                            selectIsSearchable={true}
                                                                                            selectoptions={this.state.dataSelectPais}
                                                                                            selectOnchange={(selected) => {
                                                                                                let juntas = this.state.data.congresistas_cf_juntas_asociaciones;
                                                                                                juntas[i].pais_id = selected.value;
                                                                                                juntas[i].pais_select = selected;
                                                                                                this.setState(prevState => ({
                                                                                                    ...prevState,
                                                                                                    data: {
                                                                                                        ...prevState.data,
                                                                                                        congresistas_cf_juntas_asociaciones: juntas
                                                                                                    }
                                                                                                }));
                                                                                            }}
                                                                                            selectclassNamePrefix="selectReact__value-container"
                                                                                            spanClass="error"
                                                                                        // spanError={this.state.errors["congresistas_cf_juntas_asociaciones"][i]["pais_id"] || ''}
                                                                                        >
                                                                                        </Select>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }
                                                                })
                                                            }
                                                            <div className="formCard addMore" onClick={async () => {
                                                                await this.handlerAddJuntasAsociaciones();
                                                            }}>
                                                                <i className="fas fa-plus-circle" />
                                                                <p>Agregar</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`tab-pane`} id={`tab-info-cercanias`}>
                                                    <div className="col-md-12">
                                                        <div className="formCardsContainer two-columns">
                                                            {
                                                                this.state.data.congresistas_cf_info_cercanias.map((x, i) => {
                                                                    if (x.activo === 1) {
                                                                        return (
                                                                            <div key={i} className="formCard">
                                                                                <button onClick={() => { this.handlerDeleteCercanias(x, i) }} type="button" className="deleteFormCard"><i className="fas fa-trash-alt" /></button>
                                                                                <div className="form-group">
                                                                                    <div className="col-md-12">
                                                                                        <label htmlFor="">Nombre completo</label>
                                                                                        <Input divClass="input-group"
                                                                                            inputName="trayectoria_publica_cargo"
                                                                                            inputType="text"
                                                                                            inputClass="form-control"
                                                                                            inputplaceholder="Escriba nombre"
                                                                                            inputValue={x.nombre || ''}
                                                                                            inputOnchange={e => {
                                                                                                let cercanias = this.state.data.congresistas_cf_info_cercanias;
                                                                                                cercanias[i].nombre = e.currentTarget.value;
                                                                                                this.setState(prevState => ({
                                                                                                    ...prevState,
                                                                                                    data: {
                                                                                                        ...prevState.data,
                                                                                                        congresistas_cf_info_cercanias: cercanias
                                                                                                    }
                                                                                                }));
                                                                                            }}
                                                                                            spanClass="error"
                                                                                            // spanError={this.state.errors["congresistas_cf_info_cercanias"][i]["nombre"] || ""}
                                                                                            divClassSpanType={1}
                                                                                            divClassSpan="input-group-addon"
                                                                                            divClassSpanI="fa fa-indent" />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="form-group">
                                                                                    <div className="col-md-12">
                                                                                        <label htmlFor="">Parentesco</label>
                                                                                        <Select
                                                                                            divClass=""
                                                                                            selectplaceholder="Seleccione"
                                                                                            selectValue={x.parentesco_select}
                                                                                            selectIsSearchable={true}
                                                                                            selectoptions={this.state.dataSelectParentesco}
                                                                                            selectOnchange={(selected) => {
                                                                                                let cercanias = this.state.data.congresistas_cf_info_cercanias;
                                                                                                cercanias[i].cf_parentesco_id = selected.value;
                                                                                                cercanias[i].parentesco_select = selected;
                                                                                                this.setState(prevState => ({
                                                                                                    ...prevState,
                                                                                                    data: {
                                                                                                        ...prevState.data,
                                                                                                        congresistas_cf_info_cercanias: cercanias
                                                                                                    }
                                                                                                }));
                                                                                            }}
                                                                                            selectclassNamePrefix="selectReact__value-container"
                                                                                            spanClass="error"
                                                                                        // spanError={this.state.errors["congresistas_cf_info_cercanias"][i]["cf_organo_id"] || ''}
                                                                                        >
                                                                                        </Select>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="form-group">
                                                                                    <div className="col-md-12">
                                                                                        <label htmlFor="">Posible conflicto de interés</label>
                                                                                        <textarea className="form-control" style={{whiteSpace: "pre-line", minHeight: "150px"}} value={x.conflicto_interes || ''} placeholder="Escriba conflicto" onChange={(e)=>{
                                                                                            let cercanias = this.state.data.congresistas_cf_info_cercanias;
                                                                                            cercanias[i].conflicto_interes = e.currentTarget.value;
                                                                                            this.setState(prevState => ({
                                                                                                ...prevState,
                                                                                                data: {
                                                                                                    ...prevState.data,
                                                                                                    congresistas_cf_info_cercanias: cercanias
                                                                                                }
                                                                                            }));
                                                                                        }} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }
                                                                })
                                                            }
                                                            <div className="formCard addMore" onClick={async () => {
                                                                await this.handlerAddCercanias();
                                                            }}>
                                                                <i className="fas fa-plus-circle" />
                                                                <p>Agregar</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`tab-pane`} id={`tab-ingresos`}>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label className="col-md-3 control-label">Salario anual</label>
                                                            <div className="col-md-9">
                                                                <MoneyInput
                                                                    handlerChangeMoney={ this.handlerChangeMoney }
                                                                    value={this.state.data.congresistas_cf_ingresos.salario_anual || ''}
                                                                    propertyToSetValue='salario_anual'
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="col-md-3 control-label">Gastos de representación anuales</label>
                                                            <div className="col-md-9">
                                                                <MoneyInput
                                                                    handlerChangeMoney={ this.handlerChangeMoney }
                                                                    value={this.state.data.congresistas_cf_ingresos.gasto_representacion_anual || ''}
                                                                    propertyToSetValue='gasto_representacion_anual'
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="col-md-3 control-label">Honorarios anuales</label>
                                                            <div className="col-md-9">
                                                                <MoneyInput
                                                                    handlerChangeMoney={ this.handlerChangeMoney }
                                                                    value={this.state.data.congresistas_cf_ingresos.honorario_anual || ''}
                                                                    propertyToSetValue='honorario_anual'
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="col-md-3 control-label">Total de ingresos anuales</label>
                                                            <div className="col-md-9">
                                                                <MoneyInput readOnly={true} value={this.state.data.congresistas_cf_ingresos.total_anual || ''}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label className="col-md-3 control-label">Intereses cesantías anuales</label>
                                                            <div className="col-md-9">
                                                                <MoneyInput
                                                                    handlerChangeMoney={this.handlerChangeMoney}
                                                                    value={this.state.data.congresistas_cf_ingresos.interes_cesantias_anual || ''}
                                                                    propertyToSetValue='interes_cesantias_anual'
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="col-md-3 control-label">Arriendos anuales</label>
                                                            <div className="col-md-9">
                                                                <MoneyInput
                                                                    handlerChangeMoney={this.handlerChangeMoney}
                                                                    value={this.state.data.congresistas_cf_ingresos.arriendo_anual || ''}
                                                                    propertyToSetValue='arriendo_anual'
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="col-md-3 control-label">Otros ingresos anuales</label>
                                                            <div className="col-md-9">
                                                                <MoneyInput
                                                                    handlerChangeMoney={this.handlerChangeMoney}
                                                                    value={this.state.data.congresistas_cf_ingresos.otros_anual || ''}
                                                                    propertyToSetValue='otros_anual'
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`tab-pane`} id={`tab-acreencias`}>
                                                    <div className="col-md-12">
                                                        <div className="formCardsContainer three-columns">
                                                            {
                                                                this.state.data.congresistas_cf_acreencias.map((x, i) => {
                                                                    if (x.activo === 1) {
                                                                        return (
                                                                            <div key={i} className="formCard">
                                                                                <button onClick={() => { this.handlerDeleteAcreencias(x, i) }} type="button" className="deleteFormCard"><i className="fas fa-trash-alt" /></button>
                                                                                <div className="form-group">
                                                                                    <div className="col-md-12">
                                                                                        <label htmlFor="">Concepto</label>
                                                                                        <Input
                                                                                            divClass="input-group"
                                                                                           inputName="cf_acreencia_cpt"
                                                                                           inputType="text"
                                                                                           inputClass="form-control"
                                                                                           inputplaceholder="Escriba nombre del concepto"
                                                                                           inputValue={x.cf_acreencia_cpt || ''}
                                                                                           inputOnchange={e => {
                                                                                               let acreencias = this.state.data.congresistas_cf_acreencias;
                                                                                               acreencias[i].cf_acreencia_cpt = e.currentTarget.value;
                                                                                               this.setState(prevState => ({
                                                                                                   ...prevState,
                                                                                                   data: {
                                                                                                       ...prevState.data,
                                                                                                       congresistas_cf_acreencias: acreencias
                                                                                                   }
                                                                                               }));
                                                                                           }}
                                                                                           spanClass="error"
                                                                                           divClassSpanType={1}
                                                                                           divClassSpan="input-group-addon"
                                                                                           divClassSpanI="fa fa-indent"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="form-group">
                                                                                    <div className="col-md-12">
                                                                                        <label htmlFor="">Saldo</label>
                                                                                        <MoneyInput
                                                                                            handlerChangeMoney={this.handlerChangeMoneyAcreencias}
                                                                                            index={i}
                                                                                            value={x.saldo || 0}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }
                                                                })
                                                            }
                                                            <div className="formCard addMore" onClick={async () => {
                                                                await this.handlerAddAcreencias();
                                                            }}>
                                                                <i className="fas fa-plus-circle" />
                                                                <p>Agregar</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`tab-pane`} id={`tab-bienes`}>
                                                    <div className="col-md-12">
                                                        <div className="formCardsContainer three-columns">
                                                            {
                                                                this.state.data.congresistas_cf_bienes.map((x, i) => {
                                                                    if (x.activo === 1) {
                                                                        return (
                                                                            <div key={i} className="formCard">
                                                                                <button onClick={() => { this.handlerDeleteBienes(x, i) }} type="button" className="deleteFormCard"><i className="fas fa-trash-alt" /></button>
                                                                                <div className="form-group">
                                                                                    <div className="col-md-12">
                                                                                        <label htmlFor="">Tipo de bien</label>
                                                                                        <Input
                                                                                            divClass="input-group"
                                                                                            inputName="cf_tipo_bien"
                                                                                            inputType="text"
                                                                                            inputClass="form-control"
                                                                                            inputplaceholder="Escriba nombre del tipo de bien"
                                                                                            inputValue={x.cf_tipo_bien || ''}
                                                                                            inputOnchange={e => {
                                                                                                let bienes = this.state.data.congresistas_cf_bienes;
                                                                                                bienes[i].cf_tipo_bien = e.currentTarget.value;
                                                                                                this.setState(prevState => ({
                                                                                                    ...prevState,
                                                                                                    data: {
                                                                                                        ...prevState.data,
                                                                                                        congresistas_cf_bienes: bienes
                                                                                                    }
                                                                                                }));
                                                                                            }}
                                                                                            spanClass="error"
                                                                                            divClassSpanType={1}
                                                                                            divClassSpan="input-group-addon"
                                                                                            divClassSpanI="fa fa-indent"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="form-group">
                                                                                    <div className="col-md-12">
                                                                                        <label htmlFor="">País</label>
                                                                                        <Select
                                                                                            divClass=""
                                                                                            selectplaceholder="Seleccione"
                                                                                            selectValue={x.pais_select}
                                                                                            selectIsSearchable={true}
                                                                                            selectoptions={this.state.dataSelectPais}
                                                                                            selectOnchange={async (selected) => {
                                                                                                let bienes = this.state.data.congresistas_cf_bienes;
                                                                                                bienes[i].pais_id = selected.value;
                                                                                                bienes[i].pais_select = selected;
                                                                                                this.setState({ loading: true });
                                                                                                bienes[i].dataSelectDepartamentos = await this.getComboCfDepartamentoBienes(1, bienes[i].pais_id);
                                                                                                bienes[i].departamento_select = Object.assign({}, default_item_select_departamento);

                                                                                                this.setState(prevState => ({
                                                                                                    ...prevState,
                                                                                                    data: {
                                                                                                        ...prevState.data,
                                                                                                        congresistas_cf_bienes: bienes
                                                                                                    },
                                                                                                    loading: false
                                                                                                }));

                                                                                            }}
                                                                                            selectclassNamePrefix="selectReact__value-container"
                                                                                            spanClass="error"
                                                                                        // spanError={this.state.errors["congresistas_cf_bienes"][i]["pais_id"] || ''}
                                                                                        >
                                                                                        </Select>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="form-group">
                                                                                    <div className="col-md-12">
                                                                                        <label htmlFor="">Departamento</label>
                                                                                        <Select
                                                                                            divClass=""
                                                                                            selectplaceholder="Seleccione"
                                                                                            selectValue={x.departamento_select}
                                                                                            selectIsSearchable={true}
                                                                                            selectoptions={x.dataSelectDepartamentos}
                                                                                            selectOnchange={(selected) => {
                                                                                                let bienes = this.state.data.congresistas_cf_bienes;
                                                                                                bienes[i].cf_departamento_id = selected.value;
                                                                                                bienes[i].departamento_select = selected;
                                                                                                this.setState(prevState => ({
                                                                                                    ...prevState,
                                                                                                    data: {
                                                                                                        ...prevState.data,
                                                                                                        congresistas_cf_bienes: bienes
                                                                                                    }
                                                                                                }));
                                                                                            }}
                                                                                            selectclassNamePrefix="selectReact__value-container"
                                                                                            spanClass="error"
                                                                                        // spanError={this.state.errors["congresistas_cf_bienes"][i]["cf_departamento_id"] || ''}
                                                                                        >
                                                                                        </Select>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="form-group">
                                                                                    <div className="col-md-12">
                                                                                        <label htmlFor="">Valor</label>
                                                                                        <MoneyInput
                                                                                            handlerChangeMoney={this.handlerChangeMoneyBienes}
                                                                                            index={i}
                                                                                            value={x.valor || 0}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }
                                                                })
                                                            }
                                                            <div className="formCard addMore" onClick={async () => {
                                                                await this.handlerAddBienes();
                                                            }}>
                                                                <i className="fas fa-plus-circle" />
                                                                <p>Agregar</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`tab-pane`} id={`tab-documentos`}>
                                                    <div className="col-md-12">
                                                        <div className="formCardsContainer three-columns">
                                                            {
                                                                this.state.data.congresistas_cf_documentos.map((x, i) => {
                                                                    if (x.activo === 1) {
                                                                        return (
                                                                            <div key={i} className="formCard">
                                                                                <button onClick={() => { this.handlerDeleteDocumentos(x, i) }} type="button" className="deleteFormCard"><i className="fas fa-trash-alt" /></button>
                                                                                <div className="form-group">
                                                                                    <div className="col-md-12">
                                                                                        <label htmlFor="">Tipo de documento</label>
                                                                                        <Select
                                                                                            divClass=""
                                                                                            selectplaceholder="Seleccione"
                                                                                            selectValue={x.tipo_documento_select}
                                                                                            selectIsSearchable={true}
                                                                                            selectoptions={this.state.dataSelectTipoDocumento}
                                                                                            selectOnchange={(selected) => {
                                                                                                let documentos = this.state.data.congresistas_cf_documentos;
                                                                                                documentos[i].cf_tipo_documento_id = selected.value;
                                                                                                documentos[i].tipo_documento_select = selected;
                                                                                                this.setState(prevState => ({
                                                                                                    ...prevState,
                                                                                                    data: {
                                                                                                        ...prevState.data,
                                                                                                        congresistas_cf_documentos: documentos
                                                                                                    }
                                                                                                }));
                                                                                            }}
                                                                                            selectclassNamePrefix="selectReact__value-container"
                                                                                            spanClass="error"
                                                                                        // spanError={this.state.errors["congresistas_cf_documentos"][i]["cf_tipo_documento_id"] || ''}
                                                                                        >
                                                                                        </Select>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="form-group">
                                                                                    <div className="col-md-12">
                                                                                        <label>Año</label>
                                                                                        <div className="input-group">
                                                                                            <DatePicker
                                                                                                id="dpYearInicio"
                                                                                                showInputTime={false}
                                                                                                divClass="input-group"
                                                                                                dateSelected={x.dpYear || ''}
                                                                                                onChangeDate={e => {
                                                                                                    let documentos = this.state.data.congresistas_cf_documentos;
                                                                                                    let year = new Date(e);
                                                                                                    year = year.getFullYear();

                                                                                                    documentos[i].dpYear = e;
                                                                                                    documentos[i].year = year;

                                                                                                    this.setState(prevState => ({
                                                                                                        ...prevState,
                                                                                                        data: {
                                                                                                            ...prevState.data,
                                                                                                            congresistas_cf_documentos: documentos
                                                                                                        }
                                                                                                    }));
                                                                                                }}
                                                                                                spanClass="error"
                                                                                                // spanError={this.state.errors["congresistas_cf_documentos"][i]["year"] || ''}
                                                                                                divClassSpanType={1}
                                                                                                divClassSpan="input-group-addon"
                                                                                                divClassSpanI="fa fa-calendar-alt"
                                                                                                yearPicker={true}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="form-group">
                                                                                    <div className="col-md-12">
                                                                                        <label> Documento </label>
                                                                                        <div className="input-group">
                                                                                            <FileInput fileName={x.nombre} urlToSee={x.url_documento !== "" ? auth.pathApi() + x.url_documento : ""} index={i} handlerChangeFile={this.handlerChangeFile} />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }
                                                                })
                                                            }
                                                            <div className="formCard addMore" onClick={async () => {
                                                                await this.handlerAddDocumentos();
                                                            }}>
                                                                <i className="fas fa-plus-circle" />
                                                                <p>Agregar</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="panel-footer">
                                                <ValidarPermiso IdModuloPermisoValidar={this.state.id !== 0 ? ModuloPermiso.Congresistas.Modificar : ModuloPermiso.Congresistas.Nuevo} DefaultTemplate={
                                                    <button type="button" onClick={() => { this.saveSubmit() }} className="btn btn-success pull-right"><i className="fa fa-check"></i> Guardar</button>
                                                } />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default EditarCongresistaConflictoInteres;
